export class RequestAppBootstrapInitData {
    static readonly type = '[Bootstrap] RequestAppBootstrapInitData';
}
